import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { ASSET, track } from "../lib/api";
import { useCart } from "../contexts/CartContext";
import { Button } from "../components/ui/button";
import { ArrowLeft, Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function BoxDetail() {
  const { id } = useParams();
  const [box, setBox] = useState(null);
  const { add } = useCart();
  useEffect(() => { api.get(`/boxes/${id}`).then(r => { setBox(r.data); track("box", id, "view"); }); }, [id]);
  if (!box) return <div className="container-xl py-20">Caricamento…</div>;
  return (
    <div data-testid="box-detail-page" className="container-xl py-12 grid md:grid-cols-2 gap-10">
      <div>
        <Link to="/box" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-4"><ArrowLeft className="h-4 w-4"/>Tutte le box</Link>
        <img src={ASSET(box.image)} alt={box.name} className="w-full aspect-[4/5] object-cover rounded-sm" />
      </div>
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold">{box.category} · {box.region || "Italia"}</div>
        <h1 className="editorial-heading text-5xl md:text-6xl leading-[0.95] mt-2">{box.name}</h1>
        <p className="text-muted-foreground text-lg mt-4">{box.long_description || box.description}</p>
        <div className="mt-6 text-4xl editorial-heading text-[hsl(var(--primary))]">€{box.price.toFixed(2)}</div>
        <div className="mt-2 text-sm text-muted-foreground">Per {box.serves} persone · {box.prep_time} min</div>
        <Button
          data-testid="detail-add-to-cart"
          size="lg"
          onClick={() => add({ product_id: box.id, product_type: "box", name: box.name, image: box.image, unit_price: box.price, quantity: 1, unit: "pz" })}
          className="mt-6 bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm"
        >
          Aggiungi al carrello
        </Button>
        <div className="mt-8 border-t border-border pt-6">
          <div className="text-xs font-bold uppercase tracking-[0.2em] mb-3">Contenuto della box</div>
          <ul className="space-y-2">
            {box.items.map((it, i) => (
              <li key={i} className="flex items-center gap-2 text-sm"><Check className="h-4 w-4 text-[hsl(var(--secondary))]" />{it}</li>
            ))}
          </ul>
        </div>
        {box.tags?.length > 0 && (
          <div className="mt-6 flex flex-wrap gap-2">
            {box.tags.map((t, i) => <span key={i} className="chip bg-[hsl(var(--muted))]">{t}</span>)}
          </div>
        )}
      </div>
    </div>
  );
}
